// Hooks
import { useState, useEffect } from 'react'
// Services
import { getIsSuperadmin } from '@/services/client/auth'

async function fetchSuperadminStatus(setIsSuperadmin: (value: boolean) => void) {
  const isSuperAdmin = await getIsSuperadmin()
  setIsSuperadmin(isSuperAdmin)
}

export default function useSuperadmin() {
  const [isSuperadmin, setIsSuperadmin] = useState(false)

  useEffect(() => {
    void fetchSuperadminStatus(setIsSuperadmin)
  }, [])

  return isSuperadmin
}
